import { get, post, postFormData, del } from "@/lib/api-client-v2";
import type { DocumentParseJob } from "@/types/document-parse";

const BASE = "/document-parse";

export const documentParseApi = {
  upload(file: File, title?: string): Promise<DocumentParseJob> {
    const form = new FormData();
    form.append("file", file);
    if (title) form.append("title", title);
    return postFormData<DocumentParseJob>(`${BASE}/jobs/upload`, form);
  },

  createFromText(text: string, title?: string): Promise<DocumentParseJob> {
    return post<DocumentParseJob>(`${BASE}/jobs/text`, { text, title });
  },

  createFromCameraJson(
    text: string,
    opts?: { title?: string; metadata?: Record<string, unknown> },
  ): Promise<DocumentParseJob> {
    return post<DocumentParseJob>(`${BASE}/jobs/camera-json`, {
      text,
      title: opts?.title,
      metadata: opts?.metadata,
    });
  },

  createFromCameraMultipart(
    text: string,
    opts?: {
      title?: string;
      metadata?: Record<string, unknown>;
      image?: File;
    },
  ): Promise<DocumentParseJob> {
    const form = new FormData();
    form.append("text", text);
    if (opts?.title) form.append("title", opts.title);
    if (opts?.metadata) form.append("metadata_json", JSON.stringify(opts.metadata));
    if (opts?.image) form.append("image", opts.image);
    return postFormData<DocumentParseJob>(`${BASE}/jobs/camera`, form);
  },

  getJob(id: number): Promise<DocumentParseJob> {
    return get<DocumentParseJob>(`${BASE}/jobs/${id}`);
  },

  list(limit = 50, offset = 0): Promise<{ items: DocumentParseJob[]; total: number }> {
    return get<{ items: DocumentParseJob[]; total: number }>(`${BASE}/jobs`, { limit, offset });
  },

  deleteJob(id: number): Promise<void> {
    return del<void>(`${BASE}/jobs/${id}`);
  },

  /** Поллинг до ready/error (файловые jobs). */
  async waitUntilDone(
    jobId: number,
    opts?: { intervalMs?: number; timeoutMs?: number },
  ): Promise<DocumentParseJob> {
    const intervalMs = opts?.intervalMs ?? 1000;
    const timeoutMs = opts?.timeoutMs ?? 120_000;
    const started = Date.now();
    while (Date.now() - started < timeoutMs) {
      const job = await this.getJob(jobId);
      if (job.status === "ready" || job.status === "error") return job;
      await new Promise((r) => setTimeout(r, intervalMs));
    }
    throw new Error("Истекло время ожидания обработки документа");
  },
};
